define("settings/templates/overview/edit-email", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{action (perform this.handleClose this.user)}} as |modal|>
    <modal.card @portrait={{true}}>
      <header class="o--modalHeader u--p__b__0" data-test-id="modal-header">
        <div class="o--modalHeader__title u--m__b__md">
          {{t "account.users.edit_email.change_email"}}
        </div>
        <AlertBanner @text={{t "account.users.edit_email.banner_message"}} @type="warning" />
      </header>
  
      <ModalForm @cancel={{modal.close}} @task={{task this.handleSubmit this.user}} as |form|>
        <modal.card-body>
          <form.input
            @autocomplete="email"
            @handleInput={{this.setEmail}}
            @label={{t "shared_words.email"}}
            @placeholder={{t "account.overview.basic_information.email_placeholder"}}
            @type="email"
            @validationErrors={{this.emailErrorMessage}}
            @value={{this.email}}
          />
          <form.input
            @autocomplete="email"
            @handleInput={{this.setConfirmEmail}}
            @label={{t "account.users.edit_email.confirm_label"}}
            @placeholder={{t "account.overview.basic_information.email_placeholder"}}
            @type="email"
            @validationErrors={{this.confirmEmailErrorMessage}}
            @value={{this.confirmEmail}}
          />
        </modal.card-body>
        <modal.card-footer>
          <form.footer
            @isDisabled={{this.isSubmitDisabled}}
            @submitButtonText={{t "account.users.edit_email.change_email"}}
          />
        </modal.card-footer>
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "UbOvGJrL",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0],[28,[37,2],[[30,0,[\"handleClose\"]],[30,0,[\"user\"]]],null]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[10,\"header\"],[14,0,\"o--modalHeader u--p__b__0\"],[14,\"data-test-id\",\"modal-header\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--modalHeader__title u--m__b__md\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"account.users.edit_email.change_email\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,4],null,[[\"@text\",\"@type\"],[[28,[37,3],[\"account.users.edit_email.banner_message\"],null],\"warning\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,5],null,[[\"@cancel\",\"@task\"],[[30,1,[\"close\"]],[28,[37,6],[[30,0,[\"handleSubmit\"]],[30,0,[\"user\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"input\"]],null,[[\"@autocomplete\",\"@handleInput\",\"@label\",\"@placeholder\",\"@type\",\"@validationErrors\",\"@value\"],[\"email\",[30,0,[\"setEmail\"]],[28,[37,3],[\"shared_words.email\"],null],[28,[37,3],[\"account.overview.basic_information.email_placeholder\"],null],\"email\",[30,0,[\"emailErrorMessage\"]],[30,0,[\"email\"]]]],null],[1,\"\\n        \"],[8,[30,2,[\"input\"]],null,[[\"@autocomplete\",\"@handleInput\",\"@label\",\"@placeholder\",\"@type\",\"@validationErrors\",\"@value\"],[\"email\",[30,0,[\"setConfirmEmail\"]],[28,[37,3],[\"account.users.edit_email.confirm_label\"],null],[28,[37,3],[\"account.overview.basic_information.email_placeholder\"],null],\"email\",[30,0,[\"confirmEmailErrorMessage\"]],[30,0,[\"confirmEmail\"]]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"footer\"]],null,[[\"@isDisabled\",\"@submitButtonText\"],[[30,0,[\"isSubmitDisabled\"]],[28,[37,3],[\"account.users.edit_email.change_email\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\"],false,[\"shared/modal\",\"action\",\"perform\",\"t\",\"alert-banner\",\"modal-form\",\"task\"]]",
    "moduleName": "settings/templates/overview/edit-email.hbs",
    "isStrictMode": false
  });
});